import { TableColumn } from "../table/TableColumn";

const AccessGroupEntryActionColumns : TableColumn[] = [
    {
        heading: "Name",
        accessor: "name",
        isNumeric: false,
        id: 0,
        active: true,
        translationKey:"name"
    },
    {
        heading: "Type",
        accessor: "type",
        isNumeric: false,
        id: 1,
        sortByName: "setting.settingType.nameOriginal",
        sortDirection: "asc",
        active: true,
        translationKey: "type"
    },
    {
        heading: "Device",
        accessor: "device",
        isNumeric: false,
        id: 2,
        sortByName: "deviceImprox.devName",
        sortDirection: "asc",
        active: true,
        translationKey: "device"
    },
];

export default AccessGroupEntryActionColumns;
